import { createSelector } from '@ngrx/store';
import { EntityStoreFactory } from '@pit/core-store';
import { IDtoUserRole } from '@pit/frontend-model';

export class DtoUserRoleStoreFactory extends EntityStoreFactory<IDtoUserRole> {

    private static _instance: DtoUserRoleStoreFactory = null;

    public static get instance(): DtoUserRoleStoreFactory {
        if (this._instance === null) {
            this._instance = new DtoUserRoleStoreFactory();
        }

        return this._instance;
    }

    constructor() {
        super('DtoUserRole', 'dto.user.role');
    }

    protected override doCreateSelectors() {
        super.doCreateSelectors();

        this.entitySelectors.add('get.user.roles.device', createSelector(
            this.getSelector('get.all.entities'),
            (items: IDtoUserRole[]) => items.filter(item => (item.code === 'MOBILE'))
        ));
        this.entitySelectors.add('get.user.roles.web', createSelector(
            this.getSelector('get.all.entities'),
            (items: IDtoUserRole[]) => items.filter(item => ((item.code === 'ADMIN') || (item.code === 'ADMINSUPER') || (item.code === 'DISPATCHER')))
        ));
    }

}
